import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';

import { checkId } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { RouterLink } from 'APP/router/constants';
import Entities from 'STORE';

export function useChangeActiveGroupPresenter(): void {
  const isChat = useMatch(`${RouterLink.Chat}/*`);
  const isChannel = useMatch(`${RouterLink.Channel}/*`);
  const isThread = useMatch(`${RouterLink.Thread}/*`);
  const isSchedule = useMatch(`${RouterLink.Schedule}/*`);

  useEffect(() => {
    const activeGroupId = Entities.GroupsStore.activeGroupId;
    const match = isChat || isChannel || isSchedule || isThread;
    const groupId = match?.params.id;

    if ((!match || !groupId) && activeGroupId !== null) {
      Tasks.group.setActiveGroup({ groupId: null });
      return;
    }

    if (match && checkId.isId(groupId) && groupId !== activeGroupId) {
      Tasks.group.setActiveGroup({
        groupId,
        showAlert: true,
        isChannel: !!isChannel,
      });
    }
  }, [isChat, isChannel, isSchedule, isThread]);
}
